import React from "react";
import ObsIframe from "../../../iframe-component/onboarding/ObsIframe";

const PendingPayment = () => {
  return <ObsIframe path="/tasklist/payment-pending-task" />;
};

export default React.memo(PendingPayment);
